import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './scrollable-dropdown.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DROPDOWN_MIN_HEIGHT = 410;
var DROPDOWN_HEADER_HEIGHT = 40;
var DROPDOWN_FOOTER_HEIGHT = 55;
var AllhomesScrollableDropdown = props => {
  var dropdownDecorationHeight = DROPDOWN_FOOTER_HEIGHT + (props.showResetButton ? DROPDOWN_HEADER_HEIGHT : 0);
  var style = {
    minHeight: "".concat(DROPDOWN_MIN_HEIGHT, "px"),
    maxHeight: "calc(100vh - ".concat(props.heightOffset, "px)")
  };
  var areaStyle = {
    minHeight: "".concat(DROPDOWN_MIN_HEIGHT - dropdownDecorationHeight, "px"),
    maxHeight: "calc(100vh - ".concat(props.heightOffset + dropdownDecorationHeight, "px)")
  };
  return ___EmotionJSX("div", {
    css: styles.container,
    style: style
  }, props.showResetButton && ___EmotionJSX("div", {
    css: styles.fixedHeader
  }, ___EmotionJSX("button", {
    type: "button",
    css: styles.resetButton,
    onClick: props.onResetButtonClick
  }, "Reset")), ___EmotionJSX("div", {
    css: styles.scrollableArea,
    style: areaStyle
  }, props.children), ___EmotionJSX("div", {
    css: styles.fixedFooter
  }, ___EmotionJSX(Button, {
    css: styles.applyButton,
    onClick: props.onApplyClick
  }, "Apply")));
};
AllhomesScrollableDropdown.propTypes = {
  children: PropTypes.node,
  heightOffset: PropTypes.number,
  showResetButton: PropTypes.bool,
  onApplyClick: PropTypes.func,
  onResetButtonClick: PropTypes.func
};
AllhomesScrollableDropdown.defaultProps = {
  children: undefined,
  heightOffset: 0,
  showResetButton: false,
  onApplyClick: () => {},
  onResetButtonClick: () => {}
};
export default AllhomesScrollableDropdown;